import PropTypes from 'prop-types';

import { RepromptIcon } from '@utilities';
import { formatAvailablePanelists, isContinuouslyFed } from '../../../../../../utilities/helpers';

import styles from './_index.module.scss';

const AvailablePanelists = ({ group, isLoading, status }) => {
  const isPeopleGroupResolutionPending = group.peopleGroupResolution === 'PENDING';

  const getWarningText = () => {
    const isGroupContinuouslyFed = isContinuouslyFed(group);
    if (isGroupContinuouslyFed) {
      return 'Responses may collect gradually as continuously fed sample becomes available.';
    } else {
      return 'Your survey may not collect all responses based on available sample.';
    }
  };

  return (
    <div className={styles['available-panelists']}>
      <p className={styles['available-panelists-count']}>
        Available Panelists
        <span>
          {isLoading ? (
            <RepromptIcon className={styles['available-panelists-loading-icon']} />
          ) : isPeopleGroupResolutionPending ? (
            <strong>Unavailable</strong>
          ) : (
            <strong>{formatAvailablePanelists(group)}</strong>
          )}
        </span>
      </p>
      {!isLoading && isPeopleGroupResolutionPending && (
        <p className={styles['available-panelists-pending']}>
          This People Group is still being prepared. The available panelist count for this quota
          group will be shown on the Review Survey page.
        </p>
      )}
      {!isLoading && status === 'warn' && (
        <p className={styles['available-panelists-warning']}>{getWarningText()}</p>
      )}
    </div>
  );
};

AvailablePanelists.propTypes = {
  group: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  status: PropTypes.string,
};

export default AvailablePanelists;
